import RoleGroupModal from './RoleGroupModal.vue'
import IframeModalV3 from './IframeModalV3.vue'

export const ROLE_GROUP_MODAL = 'role-group-modal-v3'
export const IFRAME_MODAL = 'iframe-modal-v3'
 